import { useState } from 'react';

const STORAGE_KEY = 'embedded_notepad_cluster_card_view_mode';
const DEFAULT_MODE = 'preview';

export const useEmbeddedNotepadCardViewMode = (initialMode = DEFAULT_MODE) => {
  const [viewMode, setViewModeState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === 'preview' || saved === 'title-only') return saved;
    } catch (error) {
      console.error('Error reading embedded notepad card view mode:', error);
    }
    return initialMode === 'title-only' ? 'title-only' : DEFAULT_MODE;
  });

  const setViewMode = (mode) => {
    const next = mode === 'title-only' ? 'title-only' : 'preview';
    setViewModeState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (error) {
      console.error('Error saving embedded notepad card view mode:', error);
    }
  };

  const showPreview = viewMode === 'preview';

  const toggleViewMode = () => {
    setViewMode(showPreview ? 'title-only' : 'preview');
  };

  return { viewMode, setViewMode, showPreview, toggleViewMode };
};
